const ShoppingCart01 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.3519 16.5h-8.558c-.9901 0-1.4852 0-1.8827-.1826a2.0005 2.0005 0 0 1-.8532-.7451c-.2346-.3692-.3013-.8598-.4348-1.8409L4.5712 6h16.4619c.3317 0 .4976 0 .6143.068a.5.5 0 0 1 .2197.2655c.045.1274.0139.2903-.0481.6162l-1.3237 6.9491c-.1763.9259-.2645 1.3888-.5032 1.7354a1.9996 1.9996 0 0 1-.8413.6962c-.3851.1696-.8564.1696-1.7989.1696Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2 2h1.3062c.246 0 .369 0 .468.0452a.5.5 0 0 1 .213.1848c.0587.0915.0761.2133.111.4569L4.5713 6m0 0 1.052 7.7314c.1334.9811.2001 1.4717.4347 1.8409.2067.3254.503.5841.8533.7451.3975.1826.8925.1826 1.8827.1826h8.5579c.9425 0 1.4138 0 1.799-.1696a2.0009 2.0009 0 0 0 .8413-.6962c.2386-.3466.3268-.8095.5032-1.7354l1.3236-6.9491c.0621-.3259.0931-.4888.0481-.6162a.4996.4996 0 0 0-.2197-.2655C21.5308 6 21.365 6 21.0332 6H4.5714ZM10 21c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Zm8 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z"
    />
  </svg>
);

export default ShoppingCart01;
